<template>
  <div class="download">
    <img
      class="image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5256743716c9b6270c1f28b051ebe232.png"
      alt=""
    />
    <div class="consult-btn" @click="bindConsult"></div>
    <AppDownloadBtn>
      <div class="download-btn">下载 betterwe星球APP</div>
    </AppDownloadBtn>
  </div>
</template>
<script>
import AppDownloadBtn from '@/components/app/download-btn/download-btn.vue'
export default {
  components: {
    AppDownloadBtn
  },
  data() {
    return {}
  },
  methods: {
    bindConsult() {
      //  location.href =  "https://work.weixin.qq.com/";
    }
  }
}
</script>
<style lang="scss" scoped>
.download {
  min-height: 100vh;
  position: relative;

  .image {
    width: 100%;
  }
  .consult-btn {
    width: 260px;
    height: 32px;
    position: absolute;
    bottom: 130px;
    left: 50%;
    transform: translate(-50%, 0%);
  }
  .download-btn {
    position: fixed;
    left: 50%;
    bottom: 36px;
    transform: translate(-50%, 0%);
    width: 327px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #6759ff;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
